import React, { forwardRef } from 'react';
import Spinner from '../Spinner/Spinner';
import { cx } from '../utils';
import './Button.css';

// variant: primary | secondary | ghost | danger | danger-solid
// size: sm | md | lg
// type default "button"; tashqaridan berilgan type (masalan "submit") o'zgarishsiz ishlatiladi.
const Button = forwardRef(function Button(
  {
    variant = 'primary',
    size = 'md',
    type = 'button',
    loading = false,
    disabled = false,
    leftIcon = null,
    rightIcon = null,
    fullWidth = false,
    iconOnly = false,
    className,
    children,
    ...rest
  },
  ref
) {
  if (process.env.NODE_ENV !== 'production' && iconOnly && !rest['aria-label']) {
    // eslint-disable-next-line no-console
    console.warn('ui/Button: iconOnly tugma uchun aria-label majburiy.');
  }

  const startIcon = loading ? <Spinner size="sm" tone="current" label="" aria-hidden="true" /> : leftIcon;

  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cx(
        'ui-btn',
        `ui-btn--${variant}`,
        `ui-btn--${size}`,
        fullWidth && 'ui-btn--full',
        iconOnly && 'ui-btn--icon-only',
        loading && 'ui-btn--loading',
        className
      )}
    >
      {iconOnly ? (
        loading ? startIcon : children
      ) : (
        <>
          {startIcon && <span className="ui-btn__icon">{startIcon}</span>}
          {children != null && children !== false && <span className="ui-btn__label">{children}</span>}
          {rightIcon && <span className="ui-btn__icon">{rightIcon}</span>}
        </>
      )}
    </button>
  );
});

export default Button;
